<p>
  <b>
    {{ 'CATALOG.DETAILS_PAGE.OUT_OF_ORDER_NOTIFICATION.ADD_TO_CART.TITLE' | translate }}
  </b>
  {{ 'CATALOG.DETAILS_PAGE.OUT_OF_ORDER_NOTIFICATION.ADD_TO_CART.LABEL' | translate }}
  <a (click)="openOtherOffersModal()">
    {{ 'CATALOG.DETAILS_PAGE.OUT_OF_ORDER_NOTIFICATION.ADD_TO_CART.LINK' | translate }}
  </a>
  {{ 'CATALOG.DETAILS_PAGE.OUT_OF_ORDER_NOTIFICATION.ADD_TO_CART.CONTENT' | translate }}
</p>
